const common = {
  // Shared buttons & labels
  save: 'Save',
  cancel: 'Cancel',
  submit: 'Submit',
  next: 'Next',
  back: 'Back',
  previous: 'Previous',
  confirm: 'Confirm',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  search: 'Search',
  filter: 'Filter',
  clear: 'Clear',
  loading: 'Loading...',
  yes: 'Yes',
  no: 'No',
  viewAll: 'View all',
  showLess: 'Show less',
  showMore: 'Show more',
  home: 'Home',
  dashboard: 'Dashboard',
  settings: 'Settings',
  // Form-related
  emailAddress: 'Email address',
  password: 'Password',
  fullName: 'Full Name',
  dateOfBirth: 'Date of Birth',
  address: 'Address',
  district: 'District',
  townCity: 'Town / City',
  contactNumber: 'Contact Number',
  mobileNumber: 'Mobile Number',
  status: 'Status',
  actions: 'Actions',
  // UI elements
  noResults: 'No results found',
  noData: 'No data available',
  selectOption: 'Select an option',
  required: 'Required',
  optional: 'Optional',
  // Time
  today: 'Today',
  tomorrow: 'Tomorrow',
  yesterday: 'Yesterday',
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
  // Actions
  upload: 'Upload',
  download: 'Download',
  preview: 'Preview',
  remove: 'Remove',
  add: 'Add',
  addNew: 'Add New',
  view: 'View',
  viewDetails: 'View Details',
  goBack: 'Go back',
  signOut: 'Sign out',
  // Profile & permissions
  profile: 'Profile',
  effectivePermissions: 'Effective Permissions',
  noPermissions: 'No feature permissions assigned',
  switchRole: 'Switch Role',
  roleSwitched: 'Switched to {{role}}',
  refresh: 'Refresh',
  reset: 'Reset',
  retry: 'Retry',
  // Notifications
  markAllRead: 'Mark all read',
  noNotifications: 'No notifications',
  notifications: 'Notifications',
  // Language
  language: 'Language',
  // Help
  help: 'Help',
  searchPlaceholder: 'Search...',
  // Status labels
  active: 'Active',
  inactive: 'Inactive',
  pending: 'Pending',
  draft: 'Draft',
  enrolled: 'Enrolled',
  enrolledStatus: 'Enrolled',
  enrolling: 'Enrolling',
  withdrawn: 'Withdrawn',
  // Misc
  all: 'All',
  none: 'None',
  other: 'Other',
  showing: 'Showing',
  of: 'of',
  results: 'results',
  items: 'items',
  item: 'item',
  students: 'students',
  student: 'student',
  teachers: 'teachers',
  teacher: 'teacher',
  staff: 'staff',
  records: 'records',
  page: 'Page',
  na: 'N/A',
  notAvailable: 'Not available',
  at: 'at',
  clearAllFilters: 'Clear all filters',
  backToDashboard: 'Back to Dashboard',
  showingCount: 'Showing',
  tryAdjustingFilters: 'Try adjusting your search or filters.',
};

export default common;